import { Space } from 'antd';

import { TabletWrapper } from '@utils/styledForDisplay';
import { FlexibleDiv } from '@components/formStyles';

import AirportSelection from './airportSelection';
import DateSelection from './dateSelection';
import DirectFlight from './directFlight';
import FlightCabinClass from './flightCabinClass';
import FlightGuestBox from './flightGuestBox';
import TripSelection from './tripSelection';
import SearchFlightButton from './searchFlightButton';
import { FlightSearchBarProvider } from '../context/flight';
import { StyledLayout, StyledContent } from './styled';

const FlightSearchBar = () => {
  return (
    <FlightSearchBarProvider>
      <StyledLayout>
        <Space size={0} direction='vertical'>
          <TripSelection />
          <TabletWrapper display='block'>
            <DirectFlight />

            <FlightCabinClass />
          </TabletWrapper>

          <StyledLayout>
            <StyledContent>
              <StyledContent>
                <AirportSelection />
                <DateSelection />
                <FlightGuestBox />
              </StyledContent>

              <SearchFlightButton />
            </StyledContent>
          </StyledLayout>

          <FlexibleDiv top={15}>
            <TabletWrapper reverse>
              <DirectFlight />
              <FlexibleDiv left={10} top={-15}>
                <FlightCabinClass />
              </FlexibleDiv>
            </TabletWrapper>
          </FlexibleDiv>
        </Space>
      </StyledLayout>
    </FlightSearchBarProvider>
  );
};

export default FlightSearchBar;
